<template>
  <header class="messages__chat__header_wrapper" :aria-label="headerAriaLabel">
    <div
      ref="chat"
      :class="[partnerIsPublication ? 'messages__chat__header--publication' : 'messages__chat__header--member']"
      class="messages__chat__header"
      tabindex="-1"
    >
      <div class="messages__chat__close">
        <router-link :to="closeChatPath" :aria-label="closeLinkAriaLabel">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.77824 0.707107C8.16877 0.316582 8.80193 0.316582 9.19246 0.707107C9.58298 1.09763 9.58298 1.7308 9.19246 2.12132L3.5356 7.77817C3.14508 8.1687 3.14508 8.80186 3.5356 9.19239L9.19246 14.8492C9.58298 15.2398 9.58298 15.8729 9.19246 16.2635C8.80193 16.654 8.16877 16.654 7.77824 16.2635L0.707177 9.19239C0.316653 8.80186 0.316653 8.1687 0.707177 7.77817L7.77824 0.707107Z"
              fill="#291E38"
            />
          </svg>
        </router-link>
      </div>
      <div class="messages__chat__partner test-partner">
        <template v-if="partnerIsPublication">
          <div class="messages__chat__partner_logo">
            <img :src="partner.publication.logo_url" alt="" aria-hidden="true" />
          </div>
          <div id="chat_header" class="messages__chat__partner_name">
            {{ partner.publication.title }}
          </div>
        </template>
        <template v-else>
          <div class="messages__chat__partner_logo">
            <img :src="partner.member.avatar_url" alt="" aria-hidden="true" />
          </div>
          <div class="messages__chat__partner_info">
            <div id="chat_header" class="messages__chat__partner_name">
              {{ partner.member.first_name }} {{ partner.member.last_name }}
            </div>
            <div id="chat_header" class="messages__chat__partner_email">
              {{ partner.member.email }}
            </div>
            <div class="messages__chat__partner_subscription_state">
              {{ partner.member.subscription_state }}
            </div>
          </div>
          <button
            class="button button--ghost button--round messages__chat__partner_toggle_details"
            type="button"
            aria-controls="messages__chat__partner_details"
            :aria-label="togglePartnerDetailsLabel"
            :aria-expanded="String(showPartnerDetails)"
            @click="togglePartnerDetails"
          >
            <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.22273 1.70711C0.832207 1.31658 0.832207 0.683417 1.22273 0.292893C1.61326 -0.0976311 2.24642 -0.0976312 2.63695 0.292893L8.2938 5.94975C8.68432 6.34027 9.31749 6.34027 9.70801 5.94975L15.3649 0.292892C15.7554 -0.097632 16.3886 -0.0976327 16.7791 0.292892C17.1696 0.683416 17.1696 1.31658 16.7791 1.70711L9.70801 8.77817C9.31749 9.1687 8.68432 9.1687 8.2938 8.77817L1.22273 1.70711Z"
              />
            </svg>
          </button>
        </template>
      </div>
    </div>
    <transition name="messages__chat__partner_details--slide">
      <div
        v-show="showPartnerDetails"
        id="messages__chat__partner_details"
        class="messages__chat__partner_details js-partner_details test-partner_details"
      >
        <div class="messages__chat__partner_details_item">
          {{ partner.member && partner.member.subscription_start }}
        </div>
        <div v-if="showExpirationDate" class="messages__chat__partner_details_item">
          {{ partner.member && (partner.member.subscription_end || partner.member.subscription_trial_end) }}
        </div>
        <div class="messages__chat__partner_details_item">
          {{ partner.member && partner.member.plan }}
        </div>
        <div class="messages__chat__partner_details_item">
          {{ partner.member && partner.member.plan_price }}
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { chatScopePath } from './route_helpers'

export default {
  name: 'ChatHeader',
  props: {
    partner: { type: Object, required: true },
    showPartnerDetails: { type: Boolean, default: false }
  },
  emits: ['v-show-partner-details-toggle'],
  computed: {
    closeChatPath() {
      return chatScopePath(this.$route.params.chatScope)
    },
    partnerIsPublication() {
      return !!this.partner.publication
    },
    togglePartnerDetailsLabel() {
      return this.i18n.$gettext('Show additional member information')
    },
    showExpirationDate() {
      const member = this.partner.member
      if (!member) {
        return false
      }

      return !!member.subscription_end || !!member.subscription_trial_end
    },
    headerAriaLabel() {
      if (this.partnerIsPublication) {
        return this.i18n.$gettext('Publication info')
      } else {
        return this.i18n.$gettext('Member info')
      }
    },
    closeLinkAriaLabel() {
      if (this.partnerIsPublication) {
        return this.i18n.$gettext('Back to publication list')
      } else {
        return this.i18n.$gettext('Back to member list')
      }
    }
  },
  methods: {
    togglePartnerDetails() {
      this.$emit('v-show-partner-details-toggle')
    }
  }
}
</script>
